import { styles } from "../ReactPdfStyles";
import { View, Text } from "@react-pdf/renderer";

function NotProjectRelatedSection({ data }: { data: Record<string, any> }) {
	return (
		<View style={[styles.section, styles.tableFontSize]}>
			<Text style={styles.tableHeader}>Project detail</Text>
			<View style={styles.row}>
				<View style={{ width: "100%", flexDirection: "column" }}>
					<View style={styles.row}>
						<Text style={styles.labelCell}>Tenant</Text>
						<Text style={[styles.valueCell, styles.borderRight]}>
							{data?.operator ?? "—"}
						</Text>
					</View>
				</View>
			</View>
		</View>
	);
}

export default NotProjectRelatedSection;
